define('modules/domain_listing/views/main',['require','exports','module','base/collectionview','backbone','lib/util','i18n','common/models/domain','../models/domain_validation','./listing_item','./empty_view','./edit_domain_popup','./confirm_delete_popup','./domain_help_popup','common/views/alert_view','common/models/appstate','common/views/max_domains_popup','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';

  var CollectionView = require('base/collectionview'),
    Backbone = require('backbone'),
    util = require('lib/util'),
    i18n = require('i18n'),
    Domain = require('common/models/domain'),
    DomainValidation = require('../models/domain_validation'),
    DomainListingItemView = require('./listing_item'),
    DomainListingEmtpyView = require('./empty_view'),
    EditDomainPopup = require('./edit_domain_popup'),
    ConfirmDeletePopup = require('./confirm_delete_popup'),
    DomainHelpPopup = require('./domain_help_popup'),
    AlertView = require('common/views/alert_view'),
    AppState = require('common/models/appstate'),
    MaxDomainsPopUp = require('common/views/max_domains_popup');

  var Controller = {
    editDomain: function (itemView) {
      var self = this;
      this.collection.onReady(function () {
        var domain = itemView.model;
        if (domain) {
          EditDomainPopup.show(domain).then(function (url) {
            domain.save(
              { url: url },
              {
                success: _.bind(self._notifyUpdated, self),
                error: function (model, response) {
                  domain.set(domain.previousAttributes());
                  if (self._isDuplicateDomainError(response)) {
                    self._notifyDuplicated();
                  } else {
                    self._notifyError();
                  }
                },
              }
            );
          });
        } else {
          Backbone.history.navigate('/domains', { trigger: true });
        }
      }, this);
    },
    createDomain: function () {
      var self = this;
      this.collection.onReady(function () {
        var domain = new Domain(),
          collection = this.collection;
        if (AppState.isMaxDomainsExceed(collection.length)) return this._displayTrialNotification();
        EditDomainPopup.show(domain).then(function (url) {
          domain.save(
            { url: url },
            {
              success: function (model) {
                self.collection.add(model);
                self.collection.trigger('sort');
                self._notifyCreated();
              },
              error: function (model, response) {
                if (self._isDuplicateDomainError(response)) {
                  self._notifyDuplicated();
                } else {
                  self._notifyError();
                }
              },
            }
          );
        });
      }, this);
    },
    deleteDomain: function (itemView, nop, domain) {
      var self = this;
      ConfirmDeletePopup.show(domain).then(function () {
        // NOTE: not binded for arity problems
        domain.destroy({
          success: _.bind(self._notifyDeleted, self),
          error: _.bind(self._notifyError, self),
        });
      });
    },
    validateDomain: function (itemView, nop, domain) {
      var self = this;
      var validator = new DomainValidation({
        url: itemView.model.get('url'),
      });
      validator.fetch({
        success: function (model) {
          itemView.model.set('is_valid', model.get('is_valid'));
          itemView.model.set('is_valid_protocol', model.get('is_valid_protocol'));
          self.showDomainValidation(model.get('is_valid'), model.get('is_valid_protocol'));
        },
        error: function () {
          self.showDomainValidation(false, false);
        },
      });
    },
    domainHelp: function () {
      this.collection.onReady(DomainHelpPopup.show);
    },
    showDomainValidation: function (isValid, isValidProtocol) {
      var alertText;
      if (isValid && isValidProtocol) {
        alertText = this.i18n.domainCheckValid;
      } else {
        alertText = this.i18n.domainCheckInvalid;
        if (isValid && !isValidProtocol) {
          alertText = this.i18n.protocolCheckInvalid;
        }
      }

      this.showAlert(alertText, isValid && isValidProtocol);
    },
    showAlert: function (message, isSuccess) {
      AlertView.showAlert({
        message: message,
        alertType: isSuccess ? 'success' : 'danger',
      });
    },
    _isDuplicateDomainError: function (response) {
      return (
        response &&
        response.responseJSON &&
        response.responseJSON.detail === 'URL cannot be duplicated'
      );
    },
    _notifyDeleted: function () {
      this.showAlert(this.i18n.domainDeleted, true);
    },
    _notifyCreated: function () {
      this.showAlert(this.i18n.domainCreated, true);
    },
    _notifyUpdated: function () {
      this.showAlert(this.i18n.domainUpdated, true);
    },
    _notifyError: function () {
      this.showAlert(this.i18n.domainError, false);
    },
    _notifyDuplicated: function () {
      this.showAlert(this.i18n.domainDuplicated, false);
    },
    _displayTrialNotification: function () {
      var popup = MaxDomainsPopUp.show();
      popup.on(
        'hide',
        _.bind(Backbone.history.navigate, Backbone.history, '/domains', { trigger: true })
      );
    },
  };

  module.exports = CollectionView.extend({
    events: {
      'click .js-add-domain': 'addDomain',
    },
    initialize: function () {
      this.listenTo(this.childVent, 'domain:delete', this.deleteDomain);
      this.listenTo(this.childVent, 'domain:validate', this.validateDomain);
      this.listenTo(this.childVent, 'domain:edit', this.editDomain);
      this.i18n = {
        domainCreated: i18n.t('domainListing.notifications.domainCreated'),
        domainUpdated: i18n.t('domainListing.notifications.domainUpdated'),
        domainDeleted: i18n.t('domainListing.notifications.domainDeleted'),
        domainDuplicated: i18n.t('domainListing.notifications.domainDuplicated'),
        domainError: i18n.t('domainListing.notifications.domainError'),
        domainCheckValid: i18n.t('domainListing.notifications.domainCheckValid'),
        domainCheckInvalid: i18n.t('domainListing.notifications.domainCheckInvalid'),
        protocolCheckInvalid: i18n.t('domainListing.notifications.protocolCheckInvalid'),
        domainCnameHelp: i18n.t('domainListing.cnameHelp'),
      };
    },
    bodyClasses: ['landingPagesGenerator', 'home'],
    template: require('ldsh!../templates/main'),
    itemContainer: '.js-list-container',
    itemView: DomainListingItemView,
    emptyViewType: DomainListingEmtpyView,
    helpers: function () {
      return {
        cnameHelp: this.collection.length ? this.i18n.domainCnameHelp : '',
      };
    },
    addDomain: function (e) {
      e.preventDefault();
      this.createDomain();
    },
    onRender: function () {
      this.$el.i18n();
    },
  });

  util.mixin(module.exports, Controller);
});

